import styled from 'styled-components';

export const StyledLogosContainer = styled.div<{ $width: string }>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    row-gap: 22px;
    width: 100%;
    height: 100%;

    /* Make each link take an equal share of the row */
    & > a {
        display: flex;
        flex: 1 1 ${({ $width }) => $width};
        align-items: center;
        justify-content: center;
    }
`;

export const StyledLogo = styled.img<{ $width: string; $invert: boolean }>`
    flex: 0 0 auto;
    width: ${({ $width }) => $width};
    aspect-ratio: 11/7;
    max-height: 100%;
    object-fit: contain;
    filter: ${({ $invert }) => ($invert ? 'invert(100%)' : 'none')};
`;
